export default __webpack_public_path__ + "bill.fdce0a59.png";